export const BRAND_NAME = 'Srk2winonline';
// Note: It is the main site url. Ex - Srk2winonline.com, etc.
export const BRAND_DOMAIN = 'srk2win.online';
// Note: It is the main site url. Ex - playnetgaming.net, etc.
export const BRAND_DOMAIN_SKIN_URL = 'srk2win.online';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'cue88.com';